// src/api/fileApi.ts
import request from '@/utils/request';

/**
 * 文件操作API模块
 */
export const fileApi = {

    /** 上传文件夹 */
    uploadFolder(files: File[], folderName: string, userName: string): Promise<any> {
        // 创建FormData对象来组织上传数据
        const formData = new FormData();

        // 添加文件夹名称和用户名
        formData.append('folderName', folderName);
        formData.append('userName', userName);

        // 添加所有文件到FormData，使用数组格式
        files.forEach((file, index) => {
            // 使用files[]作为字段名，后端可以解析为文件数组
            formData.append('files[]', file, file.name);
        });

        // 使用request.upload方法发送请求
        return request.upload('/api/file/upload/folder', formData , {
            timeout: 30000,
        });
    },

    /** 按类条件导出Excel文件 收款单 */
    exportReceiptToExcelByRequest(requestParams: any): Promise<any> {
        return request.download(`/api/export/excel/receipt`,requestParams,{
            timeout: 60000,
        });
    },
    /** 按类条件导出Excel文件 销售出库单 */
    exportSaleOutReceiptToExcel(requestParams: any): Promise<any> {
        return request.download(`/api/export/excel/sale`,requestParams,{
            timeout: 60000,
        });
    },
    /** 按类条件导出Excel文件 采购入库单 */
    exportPurchaseListToExcel(requestParams: any): Promise<any> {
        return request.download(`/api/export/excel/purchase`,requestParams,{
            timeout: 60000,
        });
    },
    /** 按类条件导出Excel文件 对账单 */
    exportReconToExcel(requestParams: any): Promise<any> {
        return request.download(`/api/export/excel/recon`,requestParams,{
            timeout: 60000,
        });
    },
};
